<template>
	<div>
		<div class="row" v-if="showReviews">
			<div class="col-12 pb-8">
				{{ pagination.totalRecords || 0 }} records
			</div>
		</div>

		<section class="artwork-grid-block">

			<div class="row justify-content-center">

				<!-- artwork results -->
				<div v-for="artwork in artworks" :key="artwork.id" class="col-12 col-md-6 col-lg-4 col-xl-3">
					<artwork-grid-item :artwork="artwork" :showReviews="showReviews" class="active"></artwork-grid-item>
				</div>

				<p v-if="artworks.length == 0" class="p-12 text-center">
					No entries found.
				</p>

			</div>
			<div class="row" v-if="!isLoading && !isError">
				<div class="col-12">
					<pagination :data="pagination" @change="onPaginationChange($event)"></pagination>
				</div>
			</div>

			<!-- loading spinner -->
			<loading-spinner v-if="isLoading"></loading-spinner>

			<div v-if="isError" class="error">
				<div class="col-12">
					<p class="text-center">
						<i class="fas fa-exclamation-triangle text-danger"></i>
						An error occurred or your security token has expired.<br>
						Please <a :href="loginPage">return to the login page</a>.
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<style>
.artwork-grid-block {
	min-height: 300px;
}
</style>

<script>
import ArtworkGridItem from './ArtworkGridItem.vue';
import Pagination from './Pagination.vue';
import LoadingSpinner from './LoadingSpinner.vue';
import { refresh } from 'aos';

export default {
	components: {
		ArtworkGridItem,
		Pagination,
		LoadingSpinner
	},

	props: {
		category: {
			type: String,
			default: ''
		},
		search: {
			type: String,
			default: ''
		},
		showReviews: {
			type: Boolean,
			default: false
		},
		reviewState: {
			type: String,
			default: ''
		}
	},

	data() {
		return {
			isLoading: false,
			isError: false,

			artworks: [
				/* // sample format
				{
					id: 1,
					title: 'Test Media #1',
					artist: 'Test Media | 2024',
					thumbnail: 'https://ravenswoodart.fireflydigital.dev/wp-content/uploads/sites/3/2024/03/file000741141463-1-1024x1024.jpg',
					thumbnail_srcset: '',
					statement: 'test images',
					link: 'https://ravenswoodart.fireflydigital.dev/artwork/test-media-1/'
				}
				*/
			],

			pagination: {
				// "currentPage": 1,
				// "recordsPerPage": 20,
				// "totalPages": 1,
			}
		}
	},

	mounted() {
		this.getArtworks(1);
	},

	watch: {
		// reload when category changes
		category: function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.getArtworks(1);
			}
		},
		reviewState: function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.getArtworks(1);
			}
		},

		search: function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.getArtworks(1);
			}
		},

		refreshPending: function (newVal, oldVal) {
			if (newVal !== oldVal && newVal === true) {
				// if pagination page exists we set it to that.
				this.getArtworks(this.pagination.currentPage ? this.pagination.currentPage : 1);
			}
		},
	},

	methods: {
		getCategories() {
			this.$store.dispatch('getCategories')
				.then((response) => {
					this.categories = this.$store.getters.getCategories;
				})
				.catch(error => {
					console.error('getCategories', error);
				});
		},

		getArtworks(page = 1) {
			this.isLoading = true;
			this.isError = false;
			this.pagination.currentPage = page;
			var recordsPerPage = this.pagination.recordsPerPage;
			var category = this.category;
			var reviewState = this.reviewState;
			var showReviews = this.showReviews;
			var search = this.search;

			// console.log('get data', page, recordsPerPage);

			this.$store.dispatch('getArtworks', { page, recordsPerPage, category, reviewState, showReviews, search })
				.then((response) => {
					// console.log('response', response);
					this.artworks = this.$store.getters.getArtworks;
					this.pagination = this.$store.getters.getPagination;
				})
				.catch(error => {
					console.error(error);
					this.isError = true;
				})
				.finally(() => {
					this.isLoading = false;
					// set refresh pending false
					this.$store.commit('setRefreshPending', false);
				});
		},

		onPaginationChange(newPage) {
			this.getArtworks(newPage);
		},
	},

	computed: {
		refreshPending() {
			return this.$store.getters.getRefreshPending;
		},

		loginPage() {
			return this.$store.getters.getLoginPage;
		}
	},
}

</script>